import * as React from "react";
import { Field, useFormikContext } from "formik";
import TimeSelect from "report/common/TimeSelect";
import MinuteOfHourInput from "report/common/MinuteOfHourInput";
import DayOfWeekSelect from "report/common/DayOfWeekSelect";
import DayOfMonthSelect from "report/common/DayOfMonthSelect";
import { Row, Col } from "components/bootstrap";
import { FREQUENCY_OPTIONS } from "report/report-configuration-page/SchedulingFrequencyForm";
import TimezoneSelect from "components/common/TimezoneSelect";
import useUserDateTime from "hooks/useUserDateTime";
const FormikTimezoneSelect = ({ id }) => {
  const { userTimezone } = useUserDateTime();
  return /* @__PURE__ */ React.createElement(Field, { name: id }, ({ field: { name, value, onChange } }) => /* @__PURE__ */ React.createElement(
    TimezoneSelect,
    {
      value: value != null ? value : userTimezone,
      clearable: false,
      onChange: (newValue) => onChange({
        target: { value: newValue, name }
      })
    }
  ));
};
const TimeAndTimezoneControls = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Col, { sm: 4 }, /* @__PURE__ */ React.createElement(TimeSelect, { id: "frequency_configuration.time", required: true })), /* @__PURE__ */ React.createElement(Col, { sm: 4 }, /* @__PURE__ */ React.createElement(FormikTimezoneSelect, { id: "frequency_configuration.timezone" })));
const FrequencyControls = () => {
  const {
    values: { frequency }
  } = useFormikContext();
  switch (frequency) {
    case FREQUENCY_OPTIONS.HOURLY.value:
      return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { sm: 4 }, /* @__PURE__ */ React.createElement(MinuteOfHourInput, { id: "frequency_configuration.time", required: true })));
    case FREQUENCY_OPTIONS.DAILY.value:
      return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { sm: 4 }, /* @__PURE__ */ React.createElement(TimeSelect, { id: "frequency_configuration.time", required: true })), /* @__PURE__ */ React.createElement(Col, { sm: 4 }, /* @__PURE__ */ React.createElement(FormikTimezoneSelect, { id: "frequency_configuration.timezone" })));
    case FREQUENCY_OPTIONS.WEEKLY.value:
      return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { sm: 4 }, /* @__PURE__ */ React.createElement(DayOfWeekSelect, { id: "frequency_configuration.day_of_week", required: true })), /* @__PURE__ */ React.createElement(TimeAndTimezoneControls, null));
    case FREQUENCY_OPTIONS.MONTHLY.value:
      return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { sm: 4 }, /* @__PURE__ */ React.createElement(DayOfMonthSelect, { id: "frequency_configuration.day_of_month", required: true })), /* @__PURE__ */ React.createElement(TimeAndTimezoneControls, null));
    default:
      return /* @__PURE__ */ React.createElement("div", null);
  }
};
export default FrequencyControls;
